import { render, staticRenderFns } from "./typeSetting.vue?vue&type=template&id=1945394c&scoped=true&"
import script from "./typeSetting.vue?vue&type=script&lang=js&"
export * from "./typeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945394c",
  null
  
)

export default component.exports